<template>
    <g
        class="y-axis line"
        :transform="`translate(${boundary.minX}, 0)`"
    >
        <line
            :x1="boundary.minX"
            :x2="boundary.minX"
            :y1="boundary.minY"
            :y2="boundary.maxY"
            :stroke="strokeColor || 'rgba(190, 190, 190, 0.8)'"
        ></line>
    </g>
</template>

<script>
export default {
    props: [
        'boundary',
        'tickPadding',
        'strokeColor'
    ]
}
</script>

<style>

</style>
